import {IconType} from '../../../design-system/atoms/Icon/IconType.enum';

export function getCommentReplyIconType(
  isReplyActive?: boolean,
  hasMyReplyComment?: boolean
): IconType {
  // 답글 닫힘 + 내가 쓴 댓글 있음
  if (!isReplyActive && !!hasMyReplyComment) {
    return IconType.ListCommentOn;
  }
  // 답글 열림 + 내가 쓴 답글 없음
  else if (!!isReplyActive && !hasMyReplyComment) {
    return IconType.ListCommentClose02Mw;
  }
  // 답글 열림 + 내가 쓴 답글 있음
  else if (!!isReplyActive && !!hasMyReplyComment) {
    return IconType.ListCommentCloseMw;
  }
  // 답글 닫힘 + 내가 쓴 답글 없음
  return IconType.ListCommentOff;
}
